import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { AdoptedRoadsSummary } from "./AdoptedRoadsSummary";

export const AdoptedRoadsLayerType: LayerType = {
  ...ConstraintsLayerType,
  Printable: undefined,
  LayerSummary: AdoptedRoadsSummary,
};
